module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/widget-advertencias.4cdf0e62.svg";